import { useState, useRef, useEffect } from "react";
import Contact from "../../sections/Contact";
import Hero from "../../sections/Hero";
import HowWeClean from "../../sections/HowWeClean";
import ServiceArea from "../../sections/ServiceArea";
import Services from "../../sections/Services";
import Steps from "../../sections/Steps";
import Testimonials from "../../sections/Testimonials";
import JobsCarousel from "../../sections/JobsCarousel";
import PackageCards from "../../sections/PackageCards";
import TrustedByStrip from "../../sections/TrustedByStrip";

export default function Landing() {
  const [selectedPackage, setSelectedPackage] = useState<string>("");
  const [showContact, setShowContact] = useState(false);
  const contactRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = "Toronto BnB Cleaning | Airbnb Turnover Service";
  }, []);

  useEffect(() => {
    if ((selectedPackage || showContact) && contactRef.current) {
      setTimeout(() => {
        contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [selectedPackage, showContact]);

  const handleSelectPackage = (packageType: string) => {
    setSelectedPackage(packageType);
    setShowContact(true);
    // Always scroll to contact form, even if already visible
    setTimeout(() => {
      contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const handleGetEstimate = () => {
    setShowContact(true);
    // Always scroll to contact form, even if already visible
    setTimeout(() => {
      contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  return (
    <>
      <Hero bgcolor="background.default" onGetEstimate={handleGetEstimate} />
      <PackageCards 
        bgcolor="background.paper" 
        onSelectPackage={handleSelectPackage}
      />
      
      {showContact && (
        <div ref={contactRef}>
          <Contact 
            bgcolor="background.paper" 
            preselectedPackage={selectedPackage} 
          />
        </div>
      )}
      
      <HowWeClean bgcolor="background.default" />
      <TrustedByStrip bgcolor="background.paper" />
      <JobsCarousel bgcolor="background.default" />
      <Steps bgcolor="background.paper" />
      <ServiceArea bgcolor="background.default" />
      {/* <Services /> */}
      {/* <Testimonials /> */}
    </>
  );
}
